module.exports = __webpack_public_path__ + "media/images/shared/logotypes/logo_alingsas-eb6473682ed6d2bee09dc0101f01b01b.png";